var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 311.908h512v102.988a8.829 8.829 0 0 1-8.828 8.828H8.828A8.829 8.829 0 0 1 0 414.896V311.908z",
    fill: "#ff4b55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.828 88.276h494.345a8.829 8.829 0 0 1 8.828 8.828v102.988H0V97.103a8.828 8.828 0 0 1 8.828-8.827z",
    fill: "#ffe15a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#73af00",
    d: "M0 200.09h512V311.9H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M261.032 144.959l26.435 79.263 83.552.648c5.097.04 7.21 6.543 3.111 9.571l-67.214 49.635 25.203 79.663c1.537 4.86-3.996 8.879-8.142 5.916L256 321.068l-67.976 48.587c-4.147 2.964-9.679-1.056-8.142-5.916l25.203-79.663-67.214-49.635c-4.1-3.028-1.987-9.533 3.111-9.571l83.552-.648 26.435-79.263c1.611-4.835 8.451-4.835 10.063 0z",
    fill: "#f5f5f5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMm);
export default __webpack_public_path__ + "static/media/mm.023f8e88c7a1d50bc82011c88addde5b.svg";
export { ForwardRef as ReactComponent };